import delve from 'dlv'
import React from 'react'
import PreviewBanner from 'src/components/shared/PreviewBanner'

import SliceManager from 'components/shared/SliceManager'
import BackToList from 'components/shared/BackToList'
import WhiteHero from 'components/shared/WhiteHero'

import { getDataDependencies, buildStaticPaths } from 'services/api'
import fetchAllSlugs from 'src/lib/Strapi/fetchAllSlugs'
import fetchContentType from 'src/lib/Strapi/fetchContentType'

const CaseStudy = ({ pageData, preview }) => {
  const whiteHero = delve(pageData, 'whiteHero')
  const slices = delve(pageData, 'slices')

  return (
    <>
      <div className="container">
        <BackToList text="Back to user stories" url={'/user-stories'} />
        {preview && <PreviewBanner />}
        {whiteHero && <WhiteHero {...whiteHero} />}
        {slices && <SliceManager slices={slices} />}
      </div>
    </>
  )
}

export async function getStaticPaths() {
  const data = await fetchAllSlugs('case-studies')
  return buildStaticPaths(data, 'user-stories')
}

export async function getStaticProps({ preview = null, params }) {
  const data = await fetchContentType(
    'case-studies',
    `filters[slug]=${params.slug}${preview ? '&publicationState=preview' : ''}`
  )
  const pageData = await getDataDependencies(delve(data, '0'))

  if (data?.length === 0 || !data) {
    return {
      props: {},
      notFound: true,
    }
  }

  return {
    props: {
      pageData,
      preview,
    },
  }
}

export default CaseStudy
